(() => {
  'use strict';
  const layout = document.querySelector('.ss-policy-layout');
  if (!layout) return;
  const policy = layout.querySelector('.ss-policy-content');
  if (!policy) return;
  policy.querySelectorAll('div.ss-policy-detail').forEach(section => {
    const heading = section.querySelector('.ss-policy-summary');
    if (!heading) return;
    const detail = document.createElement('details');
    const identifier = [...section.classList].find(name => name.startsWith('ss-detail--'));
    detail.id = section.id || (identifier ? identifier.slice(11) : '');
    const summary = document.createElement('summary');
    summary.textContent = heading.textContent;
    detail.append(summary);
    heading.remove();
    detail.append(...section.childNodes);
    section.replaceWith(detail);
  });
  const actionsTemplate = layout.querySelector('#ss-policy-actions-template');
  const firstDetail = policy.querySelector('details');
  if (actionsTemplate && firstDetail) {
    firstDetail.before(actionsTemplate.content.cloneNode(true));
    policy.querySelectorAll('[data-ss-expand]').forEach(button => {
      button.addEventListener('click', () => {
        policy.querySelectorAll('details').forEach(detail => {
          detail.open = button.dataset.ssExpand === 'yes';
        });
      });
    });
  }
  const regionSection = policy.querySelector('.regional-details');
  const regionTemplate = layout.querySelector('#ss-policy-region-template');
  if (regionSection && regionTemplate) {
    const firstRegion = regionSection.querySelector('details');
    firstRegion.before(regionTemplate.content.cloneNode(true));
    const picker = regionSection.querySelector('select');
    const status = regionSection.querySelector('[aria-live]');
    picker.addEventListener('change', () => {
      const detail = [...regionSection.querySelectorAll('details')]
        .find(item => item.id === 'refund-' + picker.value);
      if (detail) detail.open = true;
      status.textContent = detail ? status.dataset.openText : status.dataset.usText;
    });
  }
  function reveal(hash, scroll) {
    let id;
    try { id = decodeURIComponent(hash.slice(1)); } catch { return; }
    if (!id) return;
    const target = document.getElementById(id);
    if (!target || !policy.contains(target)) return;
    for (let current = target; current && current !== policy; current = current.parentElement) {
      if (current.tagName === 'DETAILS') current.open = true;
    }
    if (scroll) requestAnimationFrame(() => target.scrollIntoView({block: 'start'}));
  }
  document.addEventListener('click', event => {
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const link = event.target.closest('a[href]');
    if (!link || !policy.contains(link)) return;
    const url = new URL(link.href, location.href);
    if (url.origin !== location.origin || url.pathname !== location.pathname || !url.hash) return;
    let id;
    try { id = decodeURIComponent(url.hash.slice(1)); } catch { return; }
    const target = document.getElementById(id);
    if (!target || !policy.contains(target)) return;
    event.preventDefault();
    event.stopPropagation();
    history.pushState(null, '', url.hash);
    reveal(url.hash, true);
    const focusTarget = target.tagName === 'DETAILS' ? target.querySelector('summary') : target;
    if (focusTarget) focusTarget.focus({preventScroll: true});
  }, true);
  window.addEventListener('hashchange', () => reveal(location.hash, true));
  reveal(location.hash, Boolean(location.hash));
  let printState = [];
  window.addEventListener('beforeprint', () => {
    printState = [...policy.querySelectorAll('details')].map(detail => [detail, detail.open]);
    printState.forEach(([detail]) => { detail.open = true; });
  });
  window.addEventListener('afterprint', () => {
    printState.forEach(([detail, open]) => { detail.open = open; });
  });
})();
